import { Timestamp } from 'firebase/firestore';
import { UTCDate, utc } from '@date-fns/utc';
import { getTime } from 'date-fns';

export const formatDateForStorage = (date: string | Timestamp) => {
  let formattedDate = Timestamp.fromMillis(new Date().getTime());
  if (!date) {
    // ERROR AND RETURN UNDEFINED
    console.error('No date provided');
    return formattedDate;
  }
  if (typeof date === 'string') {
    let year, month, day;
    if (date.includes('/') && date.split('/').length === 3) {
      // DATE CAME FROM TEXT INPUT IN dd/mm/yyyy FORMAT
      month = parseInt(date.split('/')[0]);
      day = parseInt(date.split('/')[1]);
      year = parseInt(date.split('/')[2]);
    } else if (date.includes('-') && date.split('-').length === 3) {
      // DATE CAME FROM CALENDAR INPUT IN yyyy-mm-dd FORMAT
      year = parseInt(date.split('-')[0]);
      month = parseInt(date.split('-')[1]);
      day = parseInt(date.split('-')[2]);
    }
    let milliSeconds;
    if (month && day && year) {
      // @ts-expect-error TS is not recognizing the optional  UTCDate constructor
      // https://github.com/date-fns/utc?tab=readme-ov-file#utc
      milliSeconds = getTime(new UTCDate(year, month - 1, day), {
        in: utc,
      });
    }
    if (milliSeconds) {
      formattedDate = Timestamp.fromMillis(milliSeconds);
    }
    return formattedDate;
  } else if (date instanceof Date) {
    // CONVERT JS DATE TO TIMESTAMP
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    // @ts-expect-error TS is not recognizing the optional  UTCDate constructor
    // https://github.com/date-fns/utc?tab=readme-ov-file#utc
    const milliSeconds = getTime(new UTCDate(year, month, day), {
      in: utc,
    });
    formattedDate = Timestamp.fromMillis(milliSeconds);
    return formattedDate;
  } else if (date instanceof Timestamp) {
    // IF TIMESTAMP, RETURN AS IS
    return date;
  } else {
    // IF INVALID DATE FORMAT, RETURN UNDEFINED
    console.error('Invalid date format');
    return formattedDate;
  }
};
